var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { style: { display: "block" }, attrs: { "max-width": "500" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("title.edit-settings")))]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { sm: "12" } },
                [
                  _c("app-contact-search", {
                    attrs: {
                      fancy: "",
                      value: _vm.state.sale.Contact,
                      "group-id": 1,
                      label: _vm.$ct(`contact-choose-client`),
                    },
                    on: {
                      input: function ($event) {
                        return _vm.selectContact($event)
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { sm: "12" } },
                [
                  _c("app-sale-type-select", {
                    attrs: {
                      value: _vm.state.sale.Type,
                      "ignored-type-ids": [10],
                      "use-object": "",
                      label: _vm.$ct("type-choose"),
                      "contact-group-id": 1,
                      fancy: "",
                    },
                    on: {
                      input: function ($event) {
                        return _vm.onTypeChange($event)
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              on: {
                click: function ($event) {
                  return _vm.save()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.save")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }